import React, { useState, Fragment } from 'react';
import lodash from 'lodash';
import { connect } from 'react-redux';
import SideNav from 'pages/studyOverview/components/SideNav';
import StudyUsersTeam from './StudyUsersTeam';
import StudyUsersMonitors from './StudyUsersMonitors';
import {
    TwoColumnScaffold,
    LeftColumn,
    RightColumn
} from 'pages/studyOverview/components/TwoColumnScaffold';
import { actions, features, canAccessStudyPermissions } from 'common/permissions/studyPredicates';
import styles from './StudyUsers.scss';

const buildStudyUsersLinks = (studyId, studyPermissions) => {
    const links = [
        (canAccessStudyPermissions(studyPermissions, actions.VIEW, features.USERS) ||
            canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.USERS) ||
            canAccessStudyPermissions(studyPermissions, actions.VIEW, features.TEAM) ||
            canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.TEAM)

        ) && {
            to: `/study/${studyId}/users/team`,
            title: 'Team',
        },
        (canAccessStudyPermissions(studyPermissions, actions.VIEW, features.USERS) ||
            canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.USERS) ||
            canAccessStudyPermissions(studyPermissions, actions.VIEW, features.MONITORS) ||
            canAccessStudyPermissions(studyPermissions, actions.MANAGE, features.MONITORS)

        ) && {
            to: `/study/${studyId}/users/monitors`,
            title: 'Monitors',
        },
    ];
    return links.filter(link => link);
};


export function StudyUsers(props) {
    const sideNavLinks = buildStudyUsersLinks(props.study.id, props.studyPermissions);
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <Fragment>
            <TwoColumnScaffold data-cy="StudyUsers">
                <LeftColumn>
                    <SideNav
                        activeIndex={() => {
                            const foundIndex = sideNavLinks.findIndex((link) =>
                                props.location.pathname.includes(link.to)
                            );
                            setActiveIndex(foundIndex !== -1 ? foundIndex : 0);
                            return foundIndex !== -1 ? foundIndex : 0;
                        }}
                        links={sideNavLinks}
                    />
                </LeftColumn>
                <RightColumn className={styles.usersContainer} explicitRightColumnStyles ={true}>
                    {activeIndex === sideNavLinks.findIndex(link => link.to.endsWith('/users/team')) && <StudyUsersTeam />}
                    {activeIndex === sideNavLinks.findIndex(link => link.to.endsWith('/users/monitors')) && <StudyUsersMonitors />}
                </RightColumn>
            </TwoColumnScaffold>
        </Fragment>
    );
}

export default connect(state => {
    const studyPermissions = lodash.get(state, 'me.studyPermissions', {});
    return {
        studyPermissions,
    };
}
)(StudyUsers);